import React, {useEffect, useState} from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {Button, Form, Grid, Header, Icon, Input, Menu, Segment} from "semantic-ui-react";
import Axios from "axios";
import Constants from "../../../../config/constants";
import objDefault from "../../../../models/homeModel";
import {DatesRangeInput} from "semantic-ui-calendar-react";
import {staff,staff_search} from "../../../../config/staff";
import moment from "moment";

const mystyle = {
    display: "none",

};

const eyes = [
    {key: '', text: '', value: ''},
    {key: 4, text: 'Spontaneous (4)', value: 4},
    {key: 3, text: 'To sound (3)', value: 3},
    {key: 2, text: 'To pressure (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT) ', value: 1}
]
const verbal = [
    {key: '', text: '', value: ''},
    {key: 5, text: 'Orientated (5)', value: 5},
    {key: 4, text: 'Confused (4)', value: 4},
    {key: 3, text: 'Words (3)', value: 3},
    {key: 2, text: 'Sounds (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: '1'}
]
const best = [
    {key: '', text: '', value: ''},
    {key: 6, text: 'Obey commands (6)', value: 6},
    {key: 5, text: 'Localizing (5)', value: 5},
    {key: 4, text: 'Normal flexion (4)', value: 4},
    {key: 3, text: 'Abnormal flexion (3)', value: 3},
    {key: 2, text: 'Extension (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: 1}
]

const dcStatus = [

    {key: 1, text: 'COMPLETE RECOVERY', value: '1'},
    {key: 2, text: 'IMPROVED', value: '2'},
    {key: 3, text: 'NOT IMPROVED', value: '3'},
    {key: 4, text: 'DEATH ,NO AUTOPSY', value: '4'},
    {key: 5, text: 'DEATH ,AUTOPSY', value: '5'}
]
const dcType = [
    {key: 1, text: 'WITH APPOVAL', value: '1'},
    {key: 2, text: 'AGAINST ADVICE', value: '2'},
    {key: 3, text: 'BY ESCAPE', value: '3'},
    {key: 4, text: 'BY TRANSFER', value: '4'},
    {key: 5, text: 'OTHER', value: '5'},
    {key: 6, text: 'DEATH', value: '6'}
]
const ExportAdmission = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [users, setUsers] = useState([]);
    useEffect(() => {

        search()

    }, []);
    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };
    const search = async (page = 1) => {

        try {
            setUsers([])
            let result = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission?name=' + input.name + '&staff_id=' + input.staff_id + '&admission_range=' + input.admission_range + '&created_range=' + input.created_range + '&hn=' + input.hn + '&page=' + page,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            )

            setUsers(result.data.data);

        } catch (e) {
            console.log(e);
        }
    }

    const cleanPoint = (point) => {
        let p = 0
        p = point && isNaN(point) === false ? parseInt(point) : 0
        return p
    }

    const create7Td = (value) => {
        try {
            let arr = value.split('&')
            let v = ''
            let td = ''
            let table = [0,1,2,3,4,5,6,7].map((item)=>{
                if(typeof arr[item] === 'undefined') {
                    v = arr[item]
                }
                return (
                    <>
                    <td style={mystyle}>{v}</td>
                    </>
                )
            })

            return table

        }catch (e){
            console.log(e)
        }
    }
    return (
        <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>
            <br/>
            <br/>

            <div style={{flex: 1}}>
                <Grid style={{marginTop: "1em", marginLeft: "2em"}}>
                    <Grid.Row>

                        <Grid.Column width={15}>
                            <Segment color='teal' raised>
                                <Header as='h3' block>
                                    ค้นหาข้อมูล

                                </Header>

                                <Form>
                                    <Grid.Column>
                                        <Form.Group widths='equal'>

                                            <Form.Field

                                                control={Input}
                                                name='hn'
                                                label='HN'
                                                placeholder='HN'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                            <Form.Field

                                                control={Input}
                                                name='name'
                                                label='ชื่อ-นามสกุลคนไข้'
                                                placeholder='ชื่อ-นามสกุล'
                                                onChange={(e) => handleValueChange(e)}
                                            />

                                            <Form.Select

                                                fluid label='ชื่ออาจารย์'
                                                name='staff_id'
                                                value={input.staff_id}
                                                options={staff_search}
                                                placeholder='ชื่ออาจารย์'
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                                required={'true'}

                                            />

                                            <DatesRangeInput
                                                label='ช่วงเวลา admission'
                                                name="admission_range"
                                                placeholder="From - To"
                                                value={input.admission_range}
                                                iconPosition="left"
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                            />

                                            <DatesRangeInput
                                                label='ช่วงเวลา ที่บันทึกข้อมูล'
                                                name="created_range"
                                                placeholder="From - To"
                                                value={input.created_range}
                                                iconPosition="left"
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                            />

                                        </Form.Group>
                                    </Grid.Column>
                                </Form>
                                <Grid centered>
                                    <Grid.Column/>
                                    <Grid.Row centered columns={4}>
                                        <Grid.Column/>
                                        <Button icon primary
                                                onClick={() => search()}
                                        >
                                            <Icon name='search'/> ค้นหา
                                        </Button>

                                        <Grid.Column/>
                                    </Grid.Row>
                                </Grid>


                            </Segment>

                        </Grid.Column>


                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={15}>
                            <Segment color='teal' raised>
                                <ReactHTMLTableToExcel
                                    id="test-table-xls-button"
                                    className="btn btn-success"
                                    table="table-to-xls"
                                    filename="tablexls-admission"
                                    sheet="tablexls"
                                    buttonText="Download as XLS (admission)"/>
                                <br/> <br/>

                                <table id="table-to-xls" class={'table-bordered'} style={{width: '100%'}}>
                                    <tr class={'active'}>
                                        <th>#</th>
                                        <th>HN</th>
                                        <th>ชื่อ-นามสกุล</th>
                                        <th >เพศ</th>
                                        <th style={mystyle}>อายุ</th>
                                        <th style={mystyle}>เลขบัตรประชาชน</th>
                                        <th style={mystyle}>วันเกิด</th>
                                        <th>admission</th>
                                        <th>discharge</th>
                                        <th style={mystyle}>น้ำหนัก</th>
                                        <th style={mystyle}>ส่วนสูง</th>
                                        <th>Discharge status</th>
                                        <th>Discharge type</th>
                                        <th>Chief complaint</th>
                                        <th>อาจารย์</th>
                                        <th>วันที่บันทึกข้อมูล</th>
                                        <th style={mystyle}>History</th>
                                        <th style={mystyle}>Airway Assessment [A]</th>
                                        <th style={mystyle}>Airway managements [A]</th>
                                        <th style={mystyle}>Restriction of C-spine motion [A]</th>
                                        <th style={mystyle}>Breathing Assessment [B]</th>
                                        <th style={mystyle}>Breathing managements</th>
                                        <th style={mystyle}>HR/min</th>
                                        <th style={mystyle}>RR/min</th>
                                        <th style={mystyle}>Systolic BP</th>
                                        <th style={mystyle}>Diastolic BP</th>
                                        <th style={mystyle}>BT (c.)</th>
                                        <th style={mystyle}>Oxygen saturation (%)</th>
                                        <th style={mystyle}>Circulation [C] Abdomen</th>
                                        <th style={mystyle}>Active bleeding</th>
                                        <th style={mystyle}>Fractures/deformities</th>
                                        <th style={mystyle}>Circulation managements</th>
                                        <th style={mystyle}>eFAST</th>
                                        <th style={mystyle}>EKG</th>
                                        <th style={mystyle}>Eye opening (E)</th>
                                        <th style={mystyle}>Verbal response (V)</th>
                                        <th style={mystyle}>Motor response (M)</th>
                                        <th style={mystyle}>Pupil response</th>
                                        <th style={mystyle}>Exposure/Environment control [E]</th>
                                        <th style={mystyle}>Per-rectal examination</th>
                                        <th style={mystyle}>NG/OG tube</th>
                                        <th style={mystyle}>Urethral cath</th>
                                        <th style={mystyle}>Portable chest X-ray</th>
                                        <th style={mystyle}>Others (discharge)</th>
                                        <th style={mystyle}>Arterial blood gas</th>
                                        <th style={mystyle}>Allergy</th>
                                        <th style={mystyle}>ประวัติดื่มสุรา</th>
                                        <th style={mystyle}>Medication</th>
                                        <th style={mystyle}>Last meal</th>
                                        <th style={mystyle}>Past illness / Pregnancy</th>
                                        <th style={mystyle}>Events</th>
                                        <th style={mystyle}>Head - neck</th>
                                        <th style={mystyle}>Head - neck Remark</th>
                                        <th style={mystyle}>Heart - lungs</th>
                                        <th style={mystyle}>Heart - lungs Remark</th>
                                        <th style={mystyle}>Abdomen-pelvis</th>
                                        <th style={mystyle}>Abdomen-pelvis Remark</th>
                                        <th style={mystyle}>Extremities</th>
                                        <th style={mystyle}>Extremities Remark</th>
                                        <th style={mystyle}>Per-rectal exam</th>
                                        <th style={mystyle}>Per-rectal exam Remark</th>
                                        <th style={mystyle}>Neurologic</th>
                                        <th style={mystyle}>Neurologic Remark</th>
                                        <th style={mystyle}>Investigations</th>
                                        <th style={mystyle}>Admission diagnosis</th>
                                        <th style={mystyle}>Other problems</th>
                                        <th style={mystyle}>Plan of managements</th>

                                        <th style={mystyle}>managements</th>
                                        <th style={mystyle}>operation</th>
                                        <th style={mystyle}>findings</th>

                                        <th style={mystyle}>Admission diagnosis</th>
                                        <th style={mystyle}>Other diagnosis</th>
                                        <th style={mystyle}>Hospital course</th>
                                        <th style={mystyle}>Complication</th>
                                        <th style={mystyle}>Home medications</th>
                                        <th style={mystyle}>วันที่ Appointment</th>


                                        <th style={mystyle}>Ward</th>

                                        <th style={mystyle}>Resident</th>
                                        <th style={mystyle}>Division</th>
                                        <th style={mystyle}>ผู้บันทึก</th>
                                        <th style={mystyle}>รหัสผู้บันทึก</th>
                                        <th style={mystyle}>วันเวลาที่บันทึก</th>

                                        <th style={mystyle}>iss-name1</th>
                                        <th style={mystyle}>iss-name2</th>
                                        <th style={mystyle}>iss-name3</th>
                                        <th style={mystyle}>iss-name4</th>
                                        <th style={mystyle}>iss-name5</th>
                                        <th style={mystyle}>iss-name6</th>
                                        <th style={mystyle}>iss-name7</th>
                                        <th style={mystyle}>iss-name8</th>
                                        <th style={mystyle}>iss-name9</th>
                                        <th style={mystyle}>iss-name10</th>

                                        <th style={mystyle}>ISS</th>
                                        <th style={mystyle}>Revised_Trauma_Score_SBP</th>
                                        <th style={mystyle}>Revised_Trauma_Score_RR</th>
                                        <th style={mystyle}>Revised_Trauma_Score_GSC</th>
                                        <th style={mystyle}>Revised_Trauma_Score_RTS</th>
                                        <th style={mystyle}>Mechanism_of_injury_TRISS</th>
                                        <th style={mystyle}>Mechanism_of_injury_Age</th>
                                        <th style={mystyle}>Probability_of_survival</th>

                                        {/*Greenfield Risk Assessment Profile*/}
                                        <th style={mystyle}>Obesity (BMI > 30 kg/m2)</th>
                                        <th style={mystyle}>Malignancy</th>
                                        <th style={mystyle}>Abnormal coagulation (PT, PTT, INR)	</th>
                                        <th style={mystyle}>History of thromboembolism	</th>

                                        <th style={mystyle}>Femoral central venous catheter > 24hr</th>
                                        <th style={mystyle}>Transfusion ≥ 4 units in 24 hr	</th>
                                        <th style={mystyle}>Surgical procedure >2hr	</th>
                                        <th style={mystyle}>Repair or ligation of major vascular injury	</th>

                                        <th style={mystyle}>AIS head > 2</th>
                                        <th style={mystyle}>AIS chest > 2</th>
                                        <th style={mystyle}>AIS abdomen > 2</th>
                                        <th style={mystyle}>GCS score {'<'} 8 for > 4 hr</th>
                                        <th style={mystyle}>Complex lower extremity fracture (severe soft tissue damage, articular involvement, neurovascular injuries)</th>
                                        <th style={mystyle}>Pelvic fracture		</th>

                                        <th style={mystyle}>40 – 59 years</th>
                                        <th style={mystyle}>60 – 74 years</th>
                                        <th style={mystyle}>≥75 years</th>
                                        <th style={mystyle}>Total Greenfield Risk Assessment Profile</th>
                                        {/***Indication for delayed pharmacological prophylaxis*/}
                                        <th style={mystyle}>Bleeding risk : active bleeding, coagulopathy, hemodynamic instability, solid organ injury, included pre-/or post-operation</th>
                                        <th style={mystyle}>Traumatic brain injury</th>
                                        <th style={mystyle}>Spinal cord injury</th>

                                        <th style={mystyle}>Low risk ({'<'}10) || High risk (≥ 10)</th>
                                        <th style={mystyle}>Hospitalized {'<'}24hr || Hospitalized ≥24hr</th>
                                        <th style={mystyle}>Confinedtobed</th>
                                        <th style={mystyle}>Intoxication</th>
                                        <th style={mystyle}>Restraints , or etc ...</th>

                                        <th style={mystyle}>No need pharmacological prophylaxis* || Need pharmacological prophylaxis</th>
                                        <th style={mystyle}>**No Indication for delayed pharmacological prophylaxis</th>
                                        <th style={mystyle}>Enoxaparin 40 mg sc OD/ Bemiparin 3500 IU sc OD</th>
                                        <th style={mystyle}>Heparin 5,000 unit sc q 8 hr (ESRD or GFR {'<'} 30)</th>
                                        <th style={mystyle}>Presented indication for delayed pharmacological prophylaxis**</th>
                                        <th style={mystyle}>Sequential Compression Device (SCD) and Delay Pharmacological Prophylaxis (Part 2)</th>
                                        {/*Summary Greenfield*/}

                                        <th style={mystyle}>Pharmacological prophylaxis [ No Need = Y , Need = N ]</th>
                                        <th style={mystyle}>Pharmacological prophylaxis [Date]</th>

                                        <th style={mystyle}>Regimen [ Enoxaparin = Y , Heparin = N ]</th>
                                        <th style={mystyle}>Regimen [Remark]</th>

                                        <th style={mystyle}>Complication of anticoagulant [No Or Yes ]</th>
                                        <th style={mystyle}>Complication of anticoagulant [Remark]</th>

                                        <th style={mystyle}>Sequential Compressive Device [No SCD = N , Yes , on SCD = Y]</th>
                                        <th style={mystyle}>Sequential Compressive Device [Date]</th>

                                        {/*Delay Pharmacological VTE Prophylaxis for High Risk Patient (หากไม่มีข้ามไป Part3)*/}
                                        <th style={mystyle}>จำนวนวันนอน Part 2</th>
                                        <th style={mystyle}>Active bleeding D1</th>
                                        <th style={mystyle}>Active bleeding D2</th>
                                        <th style={mystyle}>Active bleeding D3</th>
                                        <th style={mystyle}>Active bleeding D4</th>
                                        <th style={mystyle}>Active bleeding D5</th>
                                        <th style={mystyle}>Active bleeding D6</th>
                                        <th style={mystyle}>Active bleeding D7</th>

                                        <th style={mystyle}>Hemodynamic instability D1</th>
                                        <th style={mystyle}>Hemodynamic instability D2</th>
                                        <th style={mystyle}>Hemodynamic instability D3</th>
                                        <th style={mystyle}>Hemodynamic instability D4</th>
                                        <th style={mystyle}>Hemodynamic instability D5</th>
                                        <th style={mystyle}>Hemodynamic instability D6</th>
                                        <th style={mystyle}>Hemodynamic instability D7</th>

                                        <th style={mystyle}>Hemoglobin drop > 2 g/dl in under 12 hr D1</th>
                                        <th style={mystyle}>Hemoglobin drop > 2 g/dl in under 12 hr D2</th>
                                        <th style={mystyle}>Hemoglobin drop > 2 g/dl in under 12 hr D3</th>
                                        <th style={mystyle}>Hemoglobin drop > 2 g/dl in under 12 hr D4</th>
                                        <th style={mystyle}>Hemoglobin drop > 2 g/dl in under 12 hr D5</th>
                                        <th style={mystyle}>Hemoglobin drop > 2 g/dl in under 12 hr D6</th>
                                        <th style={mystyle}>Hemoglobin drop > 2 g/dl in under 12 hr D7</th>

                                        <th style={mystyle}>Ongoing Blood transfusion D1</th>
                                        <th style={mystyle}>Ongoing Blood transfusion D2</th>
                                        <th style={mystyle}>Ongoing Blood transfusion D3</th>
                                        <th style={mystyle}>Ongoing Blood transfusion D4</th>
                                        <th style={mystyle}>Ongoing Blood transfusion D5</th>
                                        <th style={mystyle}>Ongoing Blood transfusion D6</th>
                                        <th style={mystyle}>Ongoing Blood transfusion D7</th>

                                        <th style={mystyle}>PT > 3 seconds above control D1</th>
                                        <th style={mystyle}>PT > 3 seconds above control D2</th>
                                        <th style={mystyle}>PT > 3 seconds above control D3</th>
                                        <th style={mystyle}>PT > 3 seconds above control D4</th>
                                        <th style={mystyle}>PT > 3 seconds above control D5</th>
                                        <th style={mystyle}>PT > 3 seconds above control D6</th>
                                        <th style={mystyle}>PT > 3 seconds above control D7</th>

                                        <th style={mystyle}>Platelet count {'<'} 50,000 /mm3 D1</th>
                                        <th style={mystyle}>Platelet count {'<'} 50,000 /mm3 D2</th>
                                        <th style={mystyle}>Platelet count {'<'} 50,000 /mm3 D3</th>
                                        <th style={mystyle}>Platelet count {'<'} 50,000 /mm3 D4</th>
                                        <th style={mystyle}>Platelet count {'<'} 50,000 /mm3 D5</th>
                                        <th style={mystyle}>Platelet count {'<'} 50,000 /mm3 D6</th>
                                        <th style={mystyle}>Platelet count {'<'} 50,000 /mm3 D7</th>

                                        <th style={mystyle}>Grade 4 or 5 solid organ injury (พิจารณาให้ delay pharmacologic prophylaxis after 72 hrs) D1</th>
                                        <th style={mystyle}>Grade 4 or 5 solid organ injury (พิจารณาให้ delay pharmacologic prophylaxis after 72 hrs) D2</th>
                                        <th style={mystyle}>Grade 4 or 5 solid organ injury (พิจารณาให้ delay pharmacologic prophylaxis after 72 hrs) D3</th>
                                        <th style={mystyle}>Grade 4 or 5 solid organ injury (พิจารณาให้ delay pharmacologic prophylaxis after 72 hrs) D4</th>
                                        <th style={mystyle}>Grade 4 or 5 solid organ injury (พิจารณาให้ delay pharmacologic prophylaxis after 72 hrs) D5</th>
                                        <th style={mystyle}>Grade 4 or 5 solid organ injury (พิจารณาให้ delay pharmacologic prophylaxis after 72 hrs) D6</th>
                                        <th style={mystyle}>Grade 4 or 5 solid organ injury (พิจารณาให้ delay pharmacologic prophylaxis after 72 hrs) D7</th>

                                        <th style={mystyle}>Traumatic Brain Injury</th>
                                        <th style={mystyle}>Intracerebral Hemorrhage</th>
                                        <th style={mystyle}>No ICH เริ่มให้ Pharmacologic prophylaxis ภายใน 72 ชั่วโมง</th>

                                        <th style={mystyle}>Progrssion of intracerebral hemorrhage on follow up CT D1</th>
                                        <th style={mystyle}>Progrssion of intracerebral hemorrhage on follow up CT D2</th>
                                        <th style={mystyle}>Progrssion of intracerebral hemorrhage on follow up CT D3</th>
                                        <th style={mystyle}>Progrssion of intracerebral hemorrhage on follow up CT D4</th>
                                        <th style={mystyle}>Progrssion of intracerebral hemorrhage on follow up CT D5</th>
                                        <th style={mystyle}>Progrssion of intracerebral hemorrhage on follow up CT D6</th>
                                        <th style={mystyle}>Progrssion of intracerebral hemorrhage on follow up CT D7</th>

                                        <th style={mystyle}>Presented sign of active bleeding D1</th>
                                        <th style={mystyle}>Presented sign of active bleeding D2</th>
                                        <th style={mystyle}>Presented sign of active bleeding D3</th>
                                        <th style={mystyle}>Presented sign of active bleeding D4</th>
                                        <th style={mystyle}>Presented sign of active bleeding D5</th>
                                        <th style={mystyle}>Presented sign of active bleeding D6</th>
                                        <th style={mystyle}>Presented sign of active bleeding D7</th>

                                        <th style={mystyle}>Spinal injury</th>

                                        <th style={mystyle}>No operation</th>
                                        <th style={mystyle}>Plan operation within 24 hr</th>
                                        <th style={mystyle}>Plan operation > 24 hr</th>

                                        <th style={mystyle}>วันที่ Duplex US</th>

                                        <th style={mystyle}>ผล No DVT</th>
                                        <th style={mystyle}>Presented DVT in</th>

                                        <th style={mystyle}>จำนวนวันนอน Part 3</th>

                                        <th style={mystyle}>Throbbing or cramping pain in leg D1</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D2</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D3</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D4</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D5</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D6</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D7</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D8</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D9</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D10</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D11</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D12</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D13</th>
                                        <th style={mystyle}>Throbbing or cramping pain in leg D14</th>

                                        <th style={mystyle}>Swelling in leg D1</th>
                                        <th style={mystyle}>Swelling in leg D2</th>
                                        <th style={mystyle}>Swelling in leg D3</th>
                                        <th style={mystyle}>Swelling in leg D4</th>
                                        <th style={mystyle}>Swelling in leg D5</th>
                                        <th style={mystyle}>Swelling in leg D6</th>
                                        <th style={mystyle}>Swelling in leg D7</th>
                                        <th style={mystyle}>Swelling in leg D8</th>
                                        <th style={mystyle}>Swelling in leg D9</th>
                                        <th style={mystyle}>Swelling in leg D10</th>
                                        <th style={mystyle}>Swelling in leg D11</th>
                                        <th style={mystyle}>Swelling in leg D12</th>
                                        <th style={mystyle}>Swelling in leg D13</th>
                                        <th style={mystyle}>Swelling in leg D14</th>

                                        <th style={mystyle}>Warm skin around painful area D1</th>
                                        <th style={mystyle}>Warm skin around painful area D2</th>
                                        <th style={mystyle}>Warm skin around painful area D3</th>
                                        <th style={mystyle}>Warm skin around painful area D4</th>
                                        <th style={mystyle}>Warm skin around painful area D5</th>
                                        <th style={mystyle}>Warm skin around painful area D6</th>
                                        <th style={mystyle}>Warm skin around painful area D7</th>
                                        <th style={mystyle}>Warm skin around painful area D8</th>
                                        <th style={mystyle}>Warm skin around painful area D9</th>
                                        <th style={mystyle}>Warm skin around painful area D10</th>
                                        <th style={mystyle}>Warm skin around painful area D11</th>
                                        <th style={mystyle}>Warm skin around painful area D12</th>
                                        <th style={mystyle}>Warm skin around painful area D13</th>
                                        <th style={mystyle}>Warm skin around painful area D14</th>

                                        <th style={mystyle}>Red and darkened skin around the painful area D1</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D2</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D3</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D4</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D5</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D6</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D7</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D8</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D9</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D10</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D11</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D12</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D13</th>
                                        <th style={mystyle}>Red and darkened skin around the painful area D14</th>

                                        <th style={mystyle}>Dyspnea D1</th>
                                        <th style={mystyle}>Dyspnea D2</th>
                                        <th style={mystyle}>Dyspnea D3</th>
                                        <th style={mystyle}>Dyspnea D4</th>
                                        <th style={mystyle}>Dyspnea D5</th>
                                        <th style={mystyle}>Dyspnea D6</th>
                                        <th style={mystyle}>Dyspnea D7</th>
                                        <th style={mystyle}>Dyspnea D8</th>
                                        <th style={mystyle}>Dyspnea D9</th>
                                        <th style={mystyle}>Dyspnea D10</th>
                                        <th style={mystyle}>Dyspnea D11</th>
                                        <th style={mystyle}>Dyspnea D12</th>
                                        <th style={mystyle}>Dyspnea D13</th>
                                        <th style={mystyle}>Dyspnea D14</th>

                                        <th style={mystyle}>Chest pain D1</th>
                                        <th style={mystyle}>Chest pain D2</th>
                                        <th style={mystyle}>Chest pain D3</th>
                                        <th style={mystyle}>Chest pain D4</th>
                                        <th style={mystyle}>Chest pain D5</th>
                                        <th style={mystyle}>Chest pain D6</th>
                                        <th style={mystyle}>Chest pain D7</th>
                                        <th style={mystyle}>Chest pain D8</th>
                                        <th style={mystyle}>Chest pain D9</th>
                                        <th style={mystyle}>Chest pain D10</th>
                                        <th style={mystyle}>Chest pain D11</th>
                                        <th style={mystyle}>Chest pain D12</th>
                                        <th style={mystyle}>Chest pain D13</th>
                                        <th style={mystyle}>Chest pain D14</th>

                                        <th style={mystyle}>Hemoptysis D1</th>
                                        <th style={mystyle}>Hemoptysis D2</th>
                                        <th style={mystyle}>Hemoptysis D3</th>
                                        <th style={mystyle}>Hemoptysis D4</th>
                                        <th style={mystyle}>Hemoptysis D5</th>
                                        <th style={mystyle}>Hemoptysis D6</th>
                                        <th style={mystyle}>Hemoptysis D7</th>
                                        <th style={mystyle}>Hemoptysis D8</th>
                                        <th style={mystyle}>Hemoptysis D9</th>
                                        <th style={mystyle}>Hemoptysis D10</th>
                                        <th style={mystyle}>Hemoptysis D11</th>
                                        <th style={mystyle}>Hemoptysis D12</th>
                                        <th style={mystyle}>Hemoptysis D13</th>
                                        <th style={mystyle}>Hemoptysis D14</th>

                                        <th style={mystyle}>Syncope/Presyncope D1</th>
                                        <th style={mystyle}>Syncope/Presyncope D2</th>
                                        <th style={mystyle}>Syncope/Presyncope D3</th>
                                        <th style={mystyle}>Syncope/Presyncope D4</th>
                                        <th style={mystyle}>Syncope/Presyncope D5</th>
                                        <th style={mystyle}>Syncope/Presyncope D6</th>
                                        <th style={mystyle}>Syncope/Presyncope D7</th>
                                        <th style={mystyle}>Syncope/Presyncope D8</th>
                                        <th style={mystyle}>Syncope/Presyncope D9</th>
                                        <th style={mystyle}>Syncope/Presyncope D10</th>
                                        <th style={mystyle}>Syncope/Presyncope D11</th>
                                        <th style={mystyle}>Syncope/Presyncope D12</th>
                                        <th style={mystyle}>Syncope/Presyncope D13</th>
                                        <th style={mystyle}>Syncope/Presyncope D14</th>

                                        <th style={mystyle}>Tachycardia D1</th>
                                        <th style={mystyle}>Tachycardia D2</th>
                                        <th style={mystyle}>Tachycardia D3</th>
                                        <th style={mystyle}>Tachycardia D4</th>
                                        <th style={mystyle}>Tachycardia D5</th>
                                        <th style={mystyle}>Tachycardia D6</th>
                                        <th style={mystyle}>Tachycardia D7</th>
                                        <th style={mystyle}>Tachycardia D8</th>
                                        <th style={mystyle}>Tachycardia D9</th>
                                        <th style={mystyle}>Tachycardia D10</th>
                                        <th style={mystyle}>Tachycardia D11</th>
                                        <th style={mystyle}>Tachycardia D12</th>
                                        <th style={mystyle}>Tachycardia D13</th>
                                        <th style={mystyle}>Tachycardia D14</th>

                                        <th style={mystyle}>Tachypnea D1</th>
                                        <th style={mystyle}>Tachypnea D2</th>
                                        <th style={mystyle}>Tachypnea D3</th>
                                        <th style={mystyle}>Tachypnea D4</th>
                                        <th style={mystyle}>Tachypnea D5</th>
                                        <th style={mystyle}>Tachypnea D6</th>
                                        <th style={mystyle}>Tachypnea D7</th>
                                        <th style={mystyle}>Tachypnea D8</th>
                                        <th style={mystyle}>Tachypnea D9</th>
                                        <th style={mystyle}>Tachypnea D10</th>
                                        <th style={mystyle}>Tachypnea D11</th>
                                        <th style={mystyle}>Tachypnea D12</th>
                                        <th style={mystyle}>Tachypnea D13</th>
                                        <th style={mystyle}>Tachypnea D14</th>

                                        <th style={mystyle}>Decrease BS D1</th>
                                        <th style={mystyle}>Decrease BS D2</th>
                                        <th style={mystyle}>Decrease BS D3</th>
                                        <th style={mystyle}>Decrease BS D4</th>
                                        <th style={mystyle}>Decrease BS D5</th>
                                        <th style={mystyle}>Decrease BS D6</th>
                                        <th style={mystyle}>Decrease BS D7</th>
                                        <th style={mystyle}>Decrease BS D8</th>
                                        <th style={mystyle}>Decrease BS D9</th>
                                        <th style={mystyle}>Decrease BS D10</th>
                                        <th style={mystyle}>Decrease BS D11</th>
                                        <th style={mystyle}>Decrease BS D12</th>
                                        <th style={mystyle}>Decrease BS D13</th>
                                        <th style={mystyle}>Decrease BS D14</th>

                                        <th style={mystyle}>Jugular v. distension D1</th>
                                        <th style={mystyle}>Jugular v. distension D2</th>
                                        <th style={mystyle}>Jugular v. distension D3</th>
                                        <th style={mystyle}>Jugular v. distension D4</th>
                                        <th style={mystyle}>Jugular v. distension D5</th>
                                        <th style={mystyle}>Jugular v. distension D6</th>
                                        <th style={mystyle}>Jugular v. distension D7</th>
                                        <th style={mystyle}>Jugular v. distension D8</th>
                                        <th style={mystyle}>Jugular v. distension D9</th>
                                        <th style={mystyle}>Jugular v. distension D10</th>
                                        <th style={mystyle}>Jugular v. distension D11</th>
                                        <th style={mystyle}>Jugular v. distension D12</th>
                                        <th style={mystyle}>Jugular v. distension D13</th>
                                        <th style={mystyle}>Jugular v. distension D14</th>

                                        <th style={mystyle}>Decrease O2 sat D1</th>
                                        <th style={mystyle}>Decrease O2 sat D2</th>
                                        <th style={mystyle}>Decrease O2 sat D3</th>
                                        <th style={mystyle}>Decrease O2 sat D4</th>
                                        <th style={mystyle}>Decrease O2 sat D5</th>
                                        <th style={mystyle}>Decrease O2 sat D6</th>
                                        <th style={mystyle}>Decrease O2 sat D7</th>
                                        <th style={mystyle}>Decrease O2 sat D8</th>
                                        <th style={mystyle}>Decrease O2 sat D9</th>
                                        <th style={mystyle}>Decrease O2 sat D10</th>
                                        <th style={mystyle}>Decrease O2 sat D11</th>
                                        <th style={mystyle}>Decrease O2 sat D12</th>
                                        <th style={mystyle}>Decrease O2 sat D13</th>
                                        <th style={mystyle}>Decrease O2 sat D14</th>

                                        <th style={mystyle}>S1Q3T3 on ECG D1</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D2</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D3</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D4</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D5</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D6</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D7</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D8</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D9</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D10</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D11</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D12</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D13</th>
                                        <th style={mystyle}>S1Q3T3 on ECG D14</th>

                                    </tr>
                                    {

                                        users.map((user, index) => (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{user.hn}</td>
                                                <td>{user.fullname}</td>
                                                <td >{user.gender}</td>
                                                <td style={mystyle}>{user.age}</td>
                                                <td style={mystyle}>'{user.citizen_id}</td>
                                                <td style={mystyle}>{moment(user.birth_date).format("DD-MM-YYYY")}</td>
                                                <td >{moment(user.admission_date).format("DD-MM-YYYY")}</td>
                                                <td >{user.discharge_date?moment(user.discharge_date).format("DD-MM-YYYY"):''}</td>
                                                <td style={mystyle}>{user.weight}</td>
                                                <td style={mystyle}>{user.height}</td>
                                                <td >{user.discharge_status?dcStatus.find(item => item.key == user.discharge_status).text:''}</td>
                                                <td >{user.discharge_type?dcType.find(item => item.key == user.discharge_type).text:''}</td>
                                                <td >{user.chief_complaint}</td>
                                                <td >{staff.find(item => item.key == user.staff_id_admission).text}</td>
                                                <td >{user.record_datetime?moment(user.record_datetime).format("DD-MM-YYYY"):''}</td>
                                                <td style={mystyle}>{user.history}</td>
                                                <td style={mystyle}>{user.primary_a}</td>
                                                <td style={mystyle}>{user.airway_managements}</td>
                                                <td style={mystyle}>{user.restriction_cspine_motion}</td>
                                                <td style={mystyle}>{user.primary_b}</td>
                                                <td style={mystyle}>{user.breathing_managements}</td>
                                                <td style={mystyle}>{user.hr}</td>
                                                <td style={mystyle}>{user.rr}</td>
                                                <td style={mystyle}>{user.bp_s}</td>
                                                <td style={mystyle}>{user.bp_d}</td>
                                                <td style={mystyle}>{user.bt}</td>
                                                <td style={mystyle}>{user.sat}</td>
                                                <td style={mystyle}>{user.primary_c}</td>
                                                <td style={mystyle}>{user.active_bleeding}</td>
                                                <td style={mystyle}>{user.fractures_deformities}</td>
                                                <td style={mystyle}>{user.managements}</td>
                                                <td style={mystyle}>{user.inv_eFAST}</td>
                                                <td style={mystyle}>{user.inv_ekg}</td>
                                                <td style={mystyle}>{eyes.find(item => item.key === user.gcs_e_admission).text}</td>
                                                <td style={mystyle}>{verbal.find(item => item.key === user.gcs_v_admission).text}</td>
                                                <td style={mystyle}>{best.find(item => item.key === user.gcs_m_admission).text}</td>
                                                <td style={mystyle}>{user.pupil_response}</td>
                                                <td style={mystyle}>{user.primary_e}</td>
                                                <td style={mystyle}>{user.pr2}</td>
                                                <td style={mystyle}>{user.ng_og_tube}</td>
                                                <td style={mystyle}>{user.urethral_cath}</td>
                                                <td style={mystyle}>{user.inv_p_cxr}</td>
                                                <td style={mystyle}>{user.inv_other}</td>
                                                <td style={mystyle}>{user.abg}</td>
                                                <td style={mystyle}>{user.allergy}</td>
                                                <td style={mystyle}>{user.alcohol_history == 'y' ? 'Yes' : 'No'}</td>
                                                <td style={mystyle}>{user.medication}</td>
                                                <td style={mystyle}>{user.last_meal}</td>
                                                <td style={mystyle}>{user.past_illness_pregnancy}</td>
                                                <td style={mystyle}>{user.events}</td>
                                                <td style={mystyle}>{user.head_neck}</td>
                                                <td style={mystyle}>{user.head_neck_remark}</td>
                                                <td style={mystyle}>{user.heart_lungs}</td>
                                                <td style={mystyle}>{user.heart_lungs_remark}</td>
                                                <td style={mystyle}>{user.abdomen_pelvis}</td>
                                                <td style={mystyle}>{user.abdomen_pelvis_remark}</td>
                                                <td style={mystyle}>{user.extremities}</td>
                                                <td style={mystyle}>{user.extremities_remark}</td>
                                                <td style={mystyle}>{user.per_rectal_exam}</td>
                                                <td style={mystyle}>{user.per_rectal_exam_remark}</td>
                                                <td style={mystyle}>{user.neurologic}</td>
                                                <td style={mystyle}>{user.neurologic_remark}</td>
                                                <td style={mystyle}>{user.investigations}</td>
                                                <td style={mystyle}>{user.primary_diagnosis}</td>
                                                <td style={mystyle}>{user.other_problems}</td>
                                                <td style={mystyle}>{user.plan_of_managements}</td>
                                                <td style={mystyle}>{user.management}</td>
                                                <td style={mystyle}>{user.operation}</td>
                                                <td style={mystyle}>{user.findings}</td>

                                                <td style={mystyle}>{user.principal_diagnosis}</td>
                                                <td style={mystyle}>{user.other_problems}</td>
                                                <td style={mystyle}>{user.hosital_course}</td>
                                                <td style={mystyle}>{user.complication}</td>
                                                <td style={mystyle}>{user.home_medications}</td>
                                                <td style={mystyle}>{user.appointment}</td>

                                                <td style={mystyle}>{user.ward}</td>
                                                <td style={mystyle}>{user.resident_name}</td>
                                                <td style={mystyle}>{user.division}</td>
                                                <td style={mystyle}>{user.record_name}</td>
                                                <td style={mystyle}>{user.recode_code}</td>
                                                <td style={mystyle}>{moment(user.record_datetime).format("DD-MM-YYYY H:mm")}</td>

                                                <td style={mystyle}>{user.iss_name1}</td>
                                                <td style={mystyle}>{user.iss_name2}</td>
                                                <td style={mystyle}>{user.iss_name3}</td>
                                                <td style={mystyle}>{user.iss_name4}</td>
                                                <td style={mystyle}>{user.iss_name5}</td>
                                                <td style={mystyle}>{user.iss_name6}</td>
                                                <td style={mystyle}>{user.iss_name7}</td>
                                                <td style={mystyle}>{user.iss_name8}</td>
                                                <td style={mystyle}>{user.iss_name9}</td>
                                                <td style={mystyle}>{user.iss_name10}</td>

                                                <td style={mystyle}>{user.iss}</td>
                                                <td style={mystyle}>{user.iss_sbp}</td>
                                                <td style={mystyle}>{user.iss_rr}</td>
                                                <td style={mystyle}>{user.iss_gcs}</td>
                                                <td style={mystyle}>{user.rts}</td>
                                                <td style={mystyle}>{user.mechanism_injury}</td>
                                                <td style={mystyle}>{user.age}</td>
                                                <td style={mystyle}>{user.triss}</td>

                                                {/*Greenfield Risk Assessment Profile*/}
                                                <td style={mystyle}>{user.vte_bmi}</td>
                                                <td style={mystyle}>{user.vte_malignancy}</td>
                                                <td style={mystyle}>{user.vte_abnormal_coagulation}</td>
                                                <td style={mystyle}>{user.vte_history_of_thromboembolism}</td>

                                                <td style={mystyle}>{user.vte_femoral_central}</td>
                                                <td style={mystyle}>{user.vte_transfusion}</td>
                                                <td style={mystyle}>{user.vte_surgical_procedure}</td>
                                                <td style={mystyle}>{user.vte_repair_ligation}</td>

                                                <td style={mystyle}>{user.vte_ais_head}</td>
                                                <td style={mystyle}>{user.vte_ais_chest}</td>
                                                <td style={mystyle}>{user.vte_ais_abdomen}</td>
                                                <td style={mystyle}>{user.vte_gcs_score}</td>
                                                <td style={mystyle}>{user.vte_complex_lower}</td>
                                                <td style={mystyle}>{user.vte_pelvic_fracture}</td>

                                                <td style={mystyle}>{user.vte_age40year}</td>
                                                <td style={mystyle}>{user.vte_age60year}</td>
                                                <td style={mystyle}>{user.vte_age75year}</td>
                                                <td style={mystyle}>{cleanPoint(user.vte_bmi) + cleanPoint(user.vte_malignancy) + cleanPoint(user.vte_abnormal_coagulation) + cleanPoint(user.vte_history_of_thromboembolism) + cleanPoint(user.vte_ais_head) + cleanPoint(user.vte_ais_chest) + cleanPoint(user.vte_ais_abdomen) + cleanPoint(user.vte_gcs_score) + cleanPoint(user.vte_complex_lower) + cleanPoint(user.vte_pelvic_fracture) + cleanPoint(user.vte_femoral_central) + cleanPoint(user.vte_transfusion) + cleanPoint(user.vte_surgical_procedure) + cleanPoint(user.vte_repair_ligation) + cleanPoint(user.vte_age40year) + cleanPoint(user.vte_age60year) + cleanPoint(user.vte_age75year)}</td>

                                                {/***Indication for delayed pharmacological prophylaxis*/}
                                                <td style={mystyle}>{user.vte_grs_bleeding}</td>
                                                <td style={mystyle}>{user.vte_grs_traumatic}</td>
                                                <td style={mystyle}>{user.vte_grs_spinal_cord}</td>

                                                <td style={mystyle}>{user.vte_grs_risk}</td>
                                                <td style={mystyle}>{user.vte_grs_hospitalize}</td>
                                                <td style={mystyle}>{user.vte_grs_confinedtobed}</td>
                                                <td style={mystyle}>{user.vte_grs_intoxication}</td>
                                                <td style={mystyle}>{user.vte_grs_restraints}</td>

                                                <td style={mystyle}>{user.vte_grs_pharmacological}</td>
                                                <td style={mystyle}>{user.vte_grs_no_indication}</td>
                                                <td style={mystyle}>{user.vte_grs_enoxaparin}</td>
                                                <td style={mystyle}>{user.vte_grs_heparin}</td>
                                                <td style={mystyle}>{user.vte_grs_presented}</td>
                                                <td style={mystyle}>{user.vte_grs_sequential}</td>

                                                {/*/!*summary GRP*!/*/}
                                                <td style={mystyle}>{user.vte_summary_need}</td>
                                                <td style={mystyle}>{user.vte_summary_need_date}</td>

                                                <td style={mystyle}>{user.vte_summary_regimen_enoxaparin_heparin}</td>
                                                <td style={mystyle}>{user.vte_summary_regiment_remark}</td>

                                                <td style={mystyle}>{user.vte_summary_complication}</td>
                                                <td style={mystyle}>{user.vte_summary_complication_remark}</td>

                                                <td style={mystyle}>{user.vte_summary_sequential}</td>
                                                <td style={mystyle}>{user.vte_summary_sequential_date}</td>

                                                {/*sleep part 1*/}
                                                <td style={mystyle}>{user.vte_sleep_part2 === null ? 0 :user.vte_sleep_part2 } วัน</td>
                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_active_bleeding !== null){
                                                            let arr = (user.vte_active_bleeding).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_hemodynamic_instability !== null){
                                                            let arr = (user.vte_hemodynamic_instability).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_hemoglobin_drop !== null){
                                                            let arr = (user.vte_hemoglobin_drop).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_ongoing_blood_transfusion !== null){
                                                            let arr = (user.vte_ongoing_blood_transfusion).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_pt !== null){
                                                            let arr = (user.vte_pt).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_platelet_count !== null){
                                                            let arr = (user.vte_platelet_count).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_grade !== null){
                                                            let arr = (user.vte_grade).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                <td style={mystyle}>{user.vte_traumatic_brain_Injury}</td>
                                                <td style={mystyle}>{user.vte_intracerebral_hemorrhage}</td>
                                                <td style={mystyle}>{user.vte_ICH}</td>

                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_progrssion !== null){
                                                            let arr = (user.vte_progrssion).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_presented !== null){
                                                            let arr = (user.vte_presented).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                                <td style={mystyle}>{user.vte_spinal_injury}</td>
                                                <td style={mystyle}>{user.vte_no_operation}</td>
                                                <td style={mystyle}>{user.vte_plan_operation_with24}</td>
                                                <td style={mystyle}>{user.vte_plan_operation_over24}</td>
                                                <td style={mystyle}>{user.vte_duplex_us_remark}</td>
                                                <td style={mystyle}>{user.vte_dvt}</td>
                                                <td style={mystyle}>{user.vte_presented_dvt_remark}</td>

                                                <td style={mystyle}>{user.vte_sleep_part3 === null ? 0 :user.vte_sleep_part3 } วัน</td>

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_throbbing_cramping !== null){
                                                            let arr = (user.vte_throbbing_cramping).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_swell !== null){
                                                            let arr = (user.vte_swell).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_warm_skin !== null){
                                                            let arr = (user.vte_warm_skin).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_reddarkened !== null){
                                                            let arr = (user.vte_reddarkened).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_dyspnea !== null){
                                                            let arr = (user.vte_dyspnea).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_chest_pain !== null){
                                                            let arr = (user.vte_chest_pain).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_hemoptysis !== null){
                                                            let arr = (user.vte_hemoptysis).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_syncope !== null){
                                                            let arr = (user.vte_syncope).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_tachycardia !== null){
                                                            let arr = (user.vte_tachycardia).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_tachypnea !== null){
                                                            let arr = (user.vte_tachypnea).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_decrease !== null){
                                                            let arr = (user.vte_decrease).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_jugular !== null){
                                                            let arr = (user.vte_jugular).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_decreaseO !== null){
                                                            let arr = (user.vte_decreaseO).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }

                                                {

                                                    [0,1,2,3,4,5,6,7,8,9,10,11,12,13].map((item)=>{
                                                        let v = ''
                                                        if(user.vte_sqt_ecg !== null){
                                                            let arr = (user.vte_sqt_ecg).split('&')

                                                            if(typeof arr[item] !== 'undefined') {
                                                                v = arr[item]
                                                            }
                                                        }
                                                        return (
                                                            <>
                                                                <td style={mystyle}>{v}</td>
                                                            </>
                                                        )
                                                    })
                                                }









                                            </tr>
                                        ))
                                    }

                                </table>
                            </Segment>

                        </Grid.Column>
                    </Grid.Row>
                </Grid>


            </div>

        </div>
    );
}


export default ExportAdmission
